import Btn from '@components/Btn';
import { HOME_BUTTON_SEPARATOR } from '@lib/constants';
import { useSelector } from 'react-redux';
import EverythingButton from '../Buttons/everythingButton';
import PersonaliseButton from '../Buttons/personaliseButton';
import ProspectusButton from '../Buttons/prospectusButton';
import StartOver from '../Buttons/startOver';

export default function ProspectusButtonsV2() {
	const { prospectusId, authenticated, authStatus } = useSelector((state) => state.user);

	if ('pending' === authStatus) {
		return (
			<>
				<Btn customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', 'skeleton']}></Btn>
				<Btn customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', 'skeleton']}></Btn>
			</>
		);
	}

	if (!authenticated) {
		return (
			<>
				<PersonaliseButton />
				{HOME_BUTTON_SEPARATOR && (
					<span className={`homeLabelSeparator  ${style.labelSeparator}`}>{HOME_BUTTON_SEPARATOR}</span>
				)}
				<EverythingButton />
			</>
		);
	}

	if (authenticated && !prospectusId) {
		return (
			<>
				<PersonaliseButton />
				{HOME_BUTTON_SEPARATOR && (
					<span className={`homeLabelSeparator  ${style.labelSeparator}`}>{HOME_BUTTON_SEPARATOR}</span>
				)}
				<EverythingButton />
			</>
		);
	}

	if (authenticated && prospectusId) {
		return (
			<>
				<ProspectusButton classes={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home']} />
				<StartOver />
			</>
		);
	}

	return <></>;
}
